<template>
  <div id="WaysToUse">
    <section id="suites">
      <Suites />
    </section>
  </div>
</template>

<script>
import Suites from "@/components/WaysToUse/Suites";

export default {
  name: "WaysToUse",
  components: {
    Suites,
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss" scoped>
#WaysToUse {
  margin: 0;
}
</style>
